import { getColor } from "./shared.js";
import { Text } from "@mantine/core";
import { jsx } from "react/jsx-runtime";

//#region src/components/typography/Caption.tsx
const Caption = ({ children, color = "gray", ta, tt, highContrast = false, "data-testid": testId }) => /* @__PURE__ */ jsx(Text, {
	lh: "150%",
	size: "xs",
	fw: 500,
	ta,
	tt,
	"data-testid": testId,
	style: {
		color: getColor(color, highContrast),
		alignContent: "center"
	},
	children
});

//#endregion
export { Caption };